/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Button, Icon, IconButton, MenuItem, Paper, Select, TextField, useTheme } from '@mui/material';
import { Environment } from '../../environment';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { date } from 'yup';
import { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';


interface IFerramentasDaListagemProps {
  textoDaBusca?: string;
  textoDoSelect?: string;
  textoDoData?: Dayjs | null;
  mostrarInputBusca?: boolean;
  mostrarInputData?: boolean;
  aoMudarTextoDeBusca?: (novoTexto: string) => void;
  aoMudarTextoDoSelect?: (novoTextoselect: string) => void;
  aoMudarData?: (novaData: Dayjs | null) => void;
  textoBotaoNovo?: string;
  mostrarBotaoNovo?: boolean;
  mostrarInputBasicSelect?: boolean
  aoClicarEmNovo?: () => void;
}
export const FerramentasDaListagemRomaneios: React.FC<IFerramentasDaListagemProps> = ({
  textoDaBusca = '',
  textoDoSelect = '',
  textoDoData = dayjs(),
  aoMudarTextoDeBusca,
  aoMudarTextoDoSelect,
  aoMudarData,
  mostrarInputBusca = false,
  mostrarInputData = false,
  mostrarInputBasicSelect = false,   
  aoClicarEmNovo,
  textoBotaoNovo = 'Novo',
  mostrarBotaoNovo = true,
}) => { 
  const theme = useTheme();
  const [dataInicial, setDataInicial] = useState<Dayjs | null>(dayjs()); 

  const handlePesquisa = () => {
    aoMudarData?.(dataInicial);
  };
   
  return (
    <Box
      gap={1}
      marginX={1}
      padding={1}
      paddingX={2}
      display="flex"
      alignItems="center"
      height={theme.spacing(6)}
      component={Paper}
    >
      {mostrarInputBasicSelect && (
        <Select
          size="small" sx={{ minWidth: 130 }}
          value={textoDoSelect}
          onChange={(event) => aoMudarTextoDoSelect?.(event.target.value)}
        >
          <MenuItem value={'r.dataemissao'}>Data Emissão</MenuItem>
          <MenuItem value={'r.numero'}>Numero</MenuItem>
          <MenuItem value={'pa.nome'}>Parceiros</MenuItem>
        </Select>
      )}

      {mostrarInputBusca && (
        <TextField
          size='small'
          value={textoDaBusca}
          placeholder={Environment.INPUT_DE_BUSCA}
          onChange={(e) => aoMudarTextoDeBusca?.(e.target.value)}
        />
      )} 

      {mostrarInputData && (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            format='DD/MM/YYYY'
            value={dataInicial}
            // onChange={aoMudarData} 
            onChange={(newValue) => setDataInicial(newValue)} 
            slotProps={{
              textField: {    
                size:'small',
              }
            }}
          />
        </LocalizationProvider>
        
      )} 
      {mostrarInputData && (
        <IconButton color='primary'>
          <SearchIcon sx={{ fontSize: 45 }} onClick={() => {handlePesquisa();}} />
        </IconButton>
        
      )} 


      <Box flex={1} display="flex" justifyContent="end">
        {mostrarBotaoNovo && (
          <Button
            color='primary'
            disableElevation
            variant='contained'
            onClick={aoClicarEmNovo}
            endIcon={<Icon>add</Icon>}
          >{textoBotaoNovo}</Button>
        )}
      </Box>
    </Box>
  );
};